<!-- <div class="box">
<form [formGroup]="formGetVoices">
  <div class="row m-tb-15">
    <div class="col-6">
      <mat-form-field class="full-width">
        <mat-label>Language</mat-label>
        <mat-select formControlName="language" (selectionChange)="voiceSelect($event)">
          <mat-option *ngFor="let voices of voicesList" [value]="companies._id">
            {{ companies.name }}
          </mat-option>
        </mat-select>
        <mat-hint>* Madatory Field</mat-hint>
      </mat-form-field>
    </div>
  </div>
</form>
</div> -->

<div class="container">
  <div class="heading-container">
    <div class="tts-heading">
      <h4 class="tss-heading-text">Text-to-Speech</h4>
    </div>

    <div class="button-container">
      <button (click)="toggleModel()" class="btn btn-primary mr-10px" style="color: #fff !important" data-toggle="modal"
        data-target="#exampleModal">
        File Upload
      </button>
      <a href="https://assets.talentlitmus.com/polly-sample.xlsx" download="polly-sample.xlsx"
        class="btn btn-primary mr-10px" style="color: #fff !important">
        Download Sample
      </a>
    </div>
  </div>

  <form style="padding: 10px" [formGroup]="ttsForm">
    <div class="row">

      <div class="col">
        <div class="form-group">
          <label for="language">Language</label>
          <select class="form-control" id="language" formControlName="language">
            <option disabled selected value>Select a language</option>
            @for (language of languages; track language) {
              <option>{{ language }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="engine">Engine</label>
          <select class="form-control" id="engine" formControlName="engine">
            <option selected value="neural">Neural</option>
            <option selected value="standard">Standard</option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="voice">Voice</label>
          <select class="form-control" id="voice" formControlName="voice">
            <option disabled selected value>Select a voice</option>
            @for (voice of voices; track voice) {
              <option [ngValue]="voice.Name"
              [disabled]="!voice.SupportedEngines.includes(ttsForm.controls.engine.value)">{{ voice.Name }}</option>
            }
          </select>
          @if (ttsForm.errors?.invalidEngine) {
            <small id="invalidEngine" class="text-danger">
              Invalid Engine
            </small>
          }
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="inputText">Input Text</label>
          <textarea class="form-control tss-txt-area" id="inputText" rows="8" formControlName="inputText"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col tts-btn-container">
        <button 
          type="button" 
          [disabled]="!ttsForm.valid" 
          class="btn btn-light tts-buttons mr-10px"
          (click)="addVoice()">Add Voice
        </button>
        <button type="button" [disabled]="!ttsForm.valid" class="btn btn-light tts-buttons mr-10px"
          (click)="submitForm()">
          Play
        </button>
        <button type="button" [disabled]="!ttsForm.valid" class="btn btn-light tts-buttons mr-10px"
          (click)="downloadAudio()">
          Download
        </button>
      </div>
    </div>
  </form>
</div>

<!--File Upload Modal -->

<ng-template #customContent let-c="close" let-d="dismiss">
  <div class="modal fade show" style="display: block; padding-right: 17px" id="exampleModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Upload File</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <form [formGroup]="fileUploadForm" (ngSubmit)="submit()">
          <div class="modal-body">
            <label for="myFile" class="fileUploadLabel">Select an excel file with less then 700 rows</label>
            <input (change)="onFileChange($event)" formControlName="file" type="file" id="myFile" name="filename" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="c('Close click')">
              Close
            </button>
            <input class="btn btn-success" type="submit" style="color: #fff !important" />
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<!-- Voice modal -->
<ng-template #voiceModal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">Add Voice</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <form #f="ngForm" (ngSubmit)="onVoiceSubmit(f)">
      <div class="modal-body">
        <div class="row m-tb-15">
          <div class="col-6">
            <mat-form-field class="full-width">
              <mat-label>Voice Name</mat-label>
              <input matInput type="text" name="name" placeholder="Voice Name" ngModel/>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-raised btn-secondary" data-dismiss="modal" (click)="c('Close click')">
          Close
        </button>
        <button type="submit" class="btn btn-raised btn-success" (click)="c('Close click')">Save</button>
      </div>
    </form>
</ng-template>